/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

if (!customElements.get('reinsurance-slider')) {
  const whenFlickityReady = () => {
    if (typeof Flickity === 'function') return Promise.resolve();
    return new Promise((resolve) => {
      document.querySelector('script[src*="vendor-v4"]').addEventListener('load', resolve, { once: true });
    });
  };

  customElements.define(
    'reinsurance-slider',
    class ReinsuranceSlider extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('.product__reinsurance-slider');
        if (!this.slider || this.slider.children.length <= 1) return;

        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = parseFloat(this.dataset.autoplaySpeed) || 5;

        whenFlickityReady().then(() => this.init());
      }

      init() {
        this.flickity = new Flickity(this.slider, {
          accessibility: false,
          rightToLeft: window.theme && theme.config ? theme.config.rtl : false,
          prevNextButtons: false,
          pageDots: true,
          wrapAround: true,
          cellAlign: 'center',
          contain: true,
          adaptiveHeight: true,
          autoPlay: this.autoplay ? this.speed * 1000 : false,
        });
      }

      disconnectedCallback() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      }
    }
  );
}
